import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

var reformatOptionRegion = function(regions) {
  return regions.map(function(region) {
    var newObj = {};
    newObj["label"] = region.region_name;
    newObj["value"] = region.region_uuid;

    return newObj;
  });
};

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionGender : [
                { label: "Laki-laki", value: "L" },
                { label: "Perempuan", value: "P" }
            ],
            selectedGender: "",
            birthOptionProvince : [],
            birthSelectedProvince: "",
            birthOptionCity : [],
            birthSelectedCity: ""
        }
    }

    // Select Area

    handleBirthSelectProvince = (birthSelectedProvince) => {
      this.setState({
        birthSelectedProvince: birthSelectedProvince.value
      });

      // get data city where province selected
      this.updateBloc.regionCityChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      
                      this.setState({
                          birthOptionCity: reformatOptionRegion(response.result)
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.updateBloc.fetchRegionCity({
        is_local: 1,
        type : 3,
        parent_uuid : birthSelectedProvince.value
      })
    }

    handleBirthSelectCity = (birthSelectedCity) => {
      this.setState({
        birthSelectedCity: birthSelectedCity.value
      });
    }

    handleSelectGender = (selectedGender) => {
        this.setState({
            selectedGender: selectedGender.value
        });
    }

    // End Select Area

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            dataForm: {
                              uuid: response.organizational_history_uuid,
                              employee_uuid: response.organizational_history_employee_uuid,
                              organizational_history_name: response.organizational_history_name,
                              organizational_history_position: response.organizational_history_position,
                              organizational_history_start_date: response.family_organizational_history_start_date,
                              organizational_history_end_date : response.family_organizational_history_end_date,
                              organizational_history_leader : response.organizational_history_leader,
                              organizational_history_place : response.organizational_history_place,
                              identity_address : response.family_identity_address,
                            //   identity_postal_code : response.family_identity_postal_code,
                            //   phone_number : response.family_phone_number
                            },
                            // selectedGender : response.family_gender,
                            // birthSelectedProvince : response.family_place_of_birth_province_uuid,
                            // birthSelectedCity : response.family_place_of_birth_city_uuid
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })

        // get data province
          this.updateBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionProvince: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionProvince({
          is_local: 1,
          type : 2  
        })

        // get data city where province selected
        this.updateBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionCity: reformatOptionRegion(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionCity({
          is_local: 1,
          type : 3,
          parent_uuid : this.state.birthSelectedProvince
        })
      
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="historiorganisasi"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Edit Histori Organisasi</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                      {/* Masih HardCode */}
                                      <AvField
                                            name="organizational_history_uuid"
                                            type="hidden"
                                            id="organizational_history_uuid"
                                            value={this.state.dataForm.organizational_history_uuid}
                                      />
                                      <AvField
                                            name="employee_uuid"
                                            type="hidden"
                                            id="employee_uuid"
                                            value={this.state.dataForm.organizational_history_employee_uuid}
                                      />
                                      {/* Sampai Sini */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="organizational_history_name"
                                                    placeholder="Nama..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="organizational_history_name"
                                                    value={this.state.dataForm.organizational_history_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Posisi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="organizational_history_position"
                                                    placeholder="Posisi..."
                                                    type="text"
                                                    errorMessage="Masukkan Posisi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="organizational_history_position"
                                                    value={this.state.dataForm.organizational_history_position}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Mulai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="organizational_history_start_date"
                                                    placeholder="Tanggal Mulai..."
                                                    type="date"
                                                    errorMessage="Masukan Tanggal Mulai"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="organizational_history_start_date"
                                                    value={this.state.dataForm.organizational_history_start_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Selesai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="organizational_history_end_date"
                                                    placeholder="Tanggal Selesai..."
                                                    type="date"
                                                    errorMessage="Masukan Tanggal Selesai"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="organizational_history_end_date"
                                                    value={this.state.dataForm.organizational_history_end_date}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Atasan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="organizational_history_leader"
                                                    placeholder="Atasan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Atasan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="organizational_history_leader"
                                                    value={this.state.dataForm.organizational_history_leader}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tempat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="organizational_history_place"
                                                    placeholder="Tempat..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Tempat"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="organizational_history_place"
                                                    value={this.state.dataForm.organizational_history_place}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="date_of_birth"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Lahir <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="date_of_birth"
                                                    placeholder="Tanggal Lahir..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Lahir"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="date_of_birth"
                                                    value={this.state.dataForm.date_of_birth}
                                                />
                                            </Col>
                                        </Row> */}
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="gender"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Kelamin <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <Select
                                                  value={
                                                    this.state.optionGender.filter(option => 
                                                      option.value === this.state.selectedGender)
                                                  }
                                                  onChange={
                                                    this.handleSelectGender
                                                  }
                                                  required="required"
                                                  options={this.state.optionGender}
                                                  classNamePrefix="select2-gender"
                                                />

                                                <AvField
                                                    name="gender"
                                                    type="hidden"
                                                    errorMessage="Pilih Jenis Kelamin"
                                                    validate={{ required: { value: true } }}
                                                    id="gender"
                                                    value={this.state.selectedGender}
                                                />
                                            </Col>
                                        </Row> */}
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="profession"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pekerjaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="profession"
                                                    placeholder="Pekerjaan..."
                                                    type="text"
                                                    errorMessage="Masukkan Pekerjaan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="profession"
                                                    value={this.state.dataForm.profession}
                                                />
                                            </Col>
                                        </Row> */}
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="alamat"
                                                className="col-md-3 col-form-label"
                                            >
                                            Alamat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="identity_address"
                                                    placeholder="Alamat..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Alamat"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="alamat"
                                                    value={this.state.dataForm.identity_address}
                                                />
                                            </Col>
                                        </Row> */}
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="identity_postal_code"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kode Pos <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="identity_postal_code"
                                                    placeholder="Kode Pos..."
                                                    type="number"
                                                    errorMessage="Masukkan Kode Pos"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="identity_postal_code"
                                                    value={this.state.dataForm.identity_postal_code}
                                                />
                                            </Col>
                                        </Row> */}
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="phone_number"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Telepon <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="phone_number"
                                                    placeholder="Nomor Telepon..."
                                                    type="number"
                                                    errorMessage="Masukkan Nomor Telepon"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="phone_number"
                                                    value={this.state.dataForm.phone_number}
                                                />
                                            </Col>
                                        </Row> */}
                                        {/* <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row> */}
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?historiorganisasi">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?historiorganisasi'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);